import React from 'react';
import { ResourceField, ResourceFormPage } from '../../components/resource/ResourceFormPage';
import { Treinamento } from '../../types/pessoas';
import { treinamentosService } from '../../services';

const fields: ResourceField<Treinamento>[] = [
  { name: 'operador', label: 'Operador (ID)', type: 'number' },
  { name: 'tipo_treinamento', label: 'Tipo de treinamento', type: 'select', options: [{ label: 'Segurança', value: 'SEGURANCA' }, { label: 'Técnico', value: 'TECNICO' }, { label: 'Qualidade', value: 'QUALIDADE' }, { label: 'Integração', value: 'INTEGRACAO' }, { label: 'Outros', value: 'OUTROS' }] },
  { name: 'data_realizacao', label: 'Data de realização', type: 'date' },
  { name: 'validade', label: 'Validade', type: 'date' },
  { name: 'resultado', label: 'Resultado', type: 'select', options: [{ label: 'Aprovado', value: 'APROVADO' }, { label: 'Reprovado', value: 'REPROVADO' }, { label: 'Pendente', value: 'PENDENTE' }] },
  { name: 'observacoes', label: 'Observações', type: 'textarea' }
];

export const TreinamentosFormPage: React.FC = () => (
  <ResourceFormPage
    title="Novo treinamento"
    description="Registre treinamentos realizados."
    fields={fields}
    service={ treinamentosService }
    redirectPath="/admin/pessoas/treinamentos"
    cancelPath="/admin/pessoas/treinamentos"
  />
);
